module.exports = __webpack_public_path__ + "static/img/jxgl-logo.88a556f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/jxgl-logo.png
// module id = +r+b
// module chunks = 96